<template>
    <div class="fixed-header-page">
        <header-nav title="消息详情"></header-nav>
        <div class="msg-page">
            <div class="header">
                <p class="title">{{result.title}}</p>
                <div class="clearfix">
                    <p class="fl">
                        发件人：{{result.senderNickname}}
                    </p>
                    <p class="fr">
                        {{result.gmtCreate}}
                    </p>
                </div>
                <div class="msg-type">
                    消息类型：<span style="color:#286ed6;">{{["全部消息","业务调整消息","价格调整消息","系统消息"][result.msgType]}}</span>
                </div>
            </div>
            <div class="msg-content">
                <div v-html="result.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                result: {}
            }
        },
        created() {
          if (this.$route.query.id) {
            this.findData(this.$route.query.id);
          } else {
            this.$toast("数据丢失了~");
          }
        },
        methods: {
            findData(id) {
                this.http.send({command: 'Message/getMessageDetail', params: {id: id}}).then(res => {
                    if (res.data.result_code == 0) {
                        this.result = res.data.body || {};
                        console.log(res);
                    }
                })
            }
        }
    }
</script>
<style>
    .msg-page{
        background: #fff;
        padding: 14px 15px;
    }
    .msg-page .header {
        color: #999999;
        font-size: 12px;
        border-bottom: 1px solid #dddddd;
        line-height: 25px;
        padding-bottom: 10px;
        margin-bottom: 15px;
    }
    .msg-page .title {
        line-height: 29px;
        text-align: center;
        font-size: 16px;
        color: #333;
        margin-bottom: 8px;
    }
    .msg-page .msg-content {
        color:#333333;
        font-size: 12px;
        line-height: 18px;
    }
</style>


// WEBPACK FOOTER //
// src/page/msgDetail.vue